import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';

export const firebaseConfig = {
    apiKey: "AIzaSyArL0bOfrVgpD_14hd0SMaToOke_xiSseE",
    authDomain: "concord-fe2ef.firebaseapp.com",
    databaseURL: "https://concord-fe2ef.firebaseio.com",
    projectId: "concord-fe2ef",
    storageBucket: "",
    messagingSenderId: "846086841811",
    appId: "1:846086841811:web:a3ccec5db2e37004"
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
// export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const db = firebase.firestore();
export const functions = firebase.functions();
